import { FC } from 'react';
import { Col, Progress, Row } from 'antd';

import { InvestmentsItem } from 'models';
import Utils from 'utils/utils';
import { language } from 'utils';

import styles from './index.module.scss';

const colors = ['#6CDF8C', '#65ABFF', '#FFD755', '#FB827A', '#212121'];

export const InvestmentStatisticRow: FC<{ el: InvestmentsItem; i: number }> = ({ el, i }) => {
	const country = el?.country === 'Lithuania' && language === 'lt' ? 'Lietuva' : el?.country;
	return (
		<Col span={24}>
			<Row justify="space-between">
				<Col className={styles.label}>
					{el?.originator ||
						Utils.formatProjectType(el?.type || '') ||
						country ||
						`${el.interestRate}%`}{' '}
					· {Number(el.part)}%
				</Col>
				<Col className={styles.label}>{Utils.moneyFormat(Number(el.amount))}</Col>
				<Col span={24}>
					<Progress
						aria-label={el.type}
						showInfo={false}
						percent={Number(el.amount) > 0 ? +el.part : 0}
						strokeColor={colors[i] || Utils.generateRandomColor()}
					/>
				</Col>
			</Row>
		</Col>
	);
};
